import { render, staticRenderFns } from "./SchoolContactManageView.vue?vue&type=template&id=7f850ad5&scoped=true&"
import script from "./SchoolContactManageView.vue?vue&type=script&lang=js&"
export * from "./SchoolContactManageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f850ad5",
  null
  
)

export default component.exports